import { render, staticRenderFns } from "./consent.vue?vue&type=template&id=f5f00f52"
import script from "./consent.ts?vue&type=script&lang=ts&external"
export * from "./consent.ts?vue&type=script&lang=ts&external"
import style0 from "./consent.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { Loader as VivaLoader } from '@/core/components'
installComponents(component, {VivaLoader})
